import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../@types/ErrorHandling'
import {
  GetAdditionalEntityDetailsClientRequest,
  GetAdditionalEntityDetailsClientResponse,
} from '../../@types/getAdditionalEntityDetails'
import { ENV } from '../../Environment'
import { api } from '../../Services/API'
import { usePolicyholderDetailsStore } from '../../Stores/policyholderDetailsStore'
import { useGetAdditionalEntityDetailsStore } from '../../Stores/useGetAdditionalEntityDetailsStore'
import { API_ROUTES } from '../../constants/apiRoutes'
import { useErrorRequest } from '../useErrorRequest'

const headers = {
  'aip-company': ENV().AdditionalEntityDetails.Company,
  'aip-channel': ENV().AdditionalEntityDetails.Channel,
}

const request = async (payload: GetAdditionalEntityDetailsClientRequest) => {
  const response = await api.post<GetAdditionalEntityDetailsClientResponse>(
    API_ROUTES.getAdditionalEntityDetails,
    payload,
    { headers },
  )

  return response.data
}

export const useGetAdditionalEntityDetails = () => {
  const { setPolicyholderAdditionalDetails } =
    useGetAdditionalEntityDetailsStore()
  const { policyholderDetailsSelected, setPhoneSelected } =
    usePolicyholderDetailsStore()
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: (payload: GetAdditionalEntityDetailsClientRequest) =>
      request(payload),
    onSuccess(data) {
      setPolicyholderAdditionalDetails(data)
      setPhoneSelected(
        policyholderDetailsSelected?.phoneContactsList?.[0]?.contactNumber ||
          data?.phoneContactList?.[0]?.phoneNumber ||
          '',
      )
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
